'use strict';

angular.module('app.information.about', [])
.config([
  '$stateProvider', 'PRODUCT', function($stateProvider, product) {
    return $stateProvider.state('app.information.about', {
      url: '/information/about',
      templateUrl: 'assets/templates/' + product.Code + '/information/aboutView.html',
      title: 'About'
    });
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/information/about/about.js